var React = require('react');

function RequestsIconInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"21.3877","cy":"55.6846","r":"20.915","fill":"#C99CEF","key":0}),React.createElement("circle",{"cx":"159.64","cy":"15.2725","r":"15.2432","fill":"#B1F8FC","key":1}),React.createElement("path",{"d":"M23.1602 56.0391H159.285V14.918","stroke":"white","strokeWidth":"2","strokeLinecap":"square","key":2}),React.createElement("path",{"d":"M23.1602 57.5391H160.785V16.418","stroke":"#143673","strokeWidth":"2","strokeLinecap":"square","key":3})]);
}

RequestsIconInline.defaultProps = {"width":"175","height":"77","viewBox":"0 0 175 77","fill":"none"};

module.exports = RequestsIconInline;

RequestsIconInline.default = RequestsIconInline;
